import { NavLink } from 'react-router-dom';
import { FaHome, FaUniversity, FaBalanceScale, FaBullseye, FaTrophy } from 'react-icons/fa';

const MobileBottomNav = () => {
  const navItems = [
    { path: '/', label: 'Home', icon: FaHome },
    { path: '/predictor', label: 'Predictor', icon: FaBullseye },
    { path: '/cutoffs', label: 'Compare', icon: FaBalanceScale },
    { path: '/colleges', label: 'Colleges', icon: FaUniversity },
    { path: '/best-colleges', label: 'Best', icon: FaTrophy },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-40 safe-area-bottom">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 transition-colors ${
                isActive
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-gray-600 hover:text-primary-600 hover:bg-gray-50'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <item.icon className={`text-xl ${isActive ? 'scale-110' : ''}`} />
                <span className={`text-[10px] font-medium ${isActive ? 'font-semibold' : ''}`}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
